// yonerge onayla
import JwtService from "@/services/jwt";
import StorageService from "./storage";
import type {IYonerge} from "@/model/yonerge";
import {type IYonergeDTO, mapYonergeFromDTO} from "@/model/yonerge.dto";
import ApiService, {type ApiError} from "./api";
import LogService, {LogIslem, LogSayfa} from "./log";

const STORAGE_PREFIX = "ynr:";

class YonergeService {
  static async getYonerge(): Promise<[ApiError, IYonerge]> {
    const startTime = performance.now();
    const [err, resp] = await ApiService.get<IYonergeDTO>(`yonerge`);
    if (err) {
      LogService.log(LogSayfa.YONERGE, LogIslem.HATA, {
        err,
        resp,
        delay: performance.now() - startTime
      });
      return [err, {} as IYonerge];
    }
    LogService.log(LogSayfa.YONERGE, LogIslem.YONERGE_GORUNTULEME)
    return [null, mapYonergeFromDTO(resp!.data)];
  }

  static onayla(): void {
    const storageKey = YonergeService.buildStorageKey();
    StorageService.set(storageKey, "OK");
    LogService.log(LogSayfa.YONERGE, LogIslem.YONERGE_ONAY)
  }

  static onaylandiMi(): boolean {
    const storageKey = YonergeService.buildStorageKey();
    return StorageService.get(storageKey) === "OK";
  }

  private static buildStorageKey(): string {
    const yarismaciID = JwtService.getTokenObj().yaid;
    const yarismaID = JwtService.getTokenObj().yid;

    return `${STORAGE_PREFIX}${yarismaciID}:${yarismaID}`;
  }
}

export default YonergeService;
